import {
    PageTitleText 
 } from '../../../../widget/styledComponents/headings.style';

import {
    AddNewEstateContainer,AddNewEstateContainerTitleSection
 } from './addEstate.style';

import {
    AppInputField,InputFieldTitleText,AppInputFieldBtn,AppInputFieldBtnCancel 
} from './../../../../widget/styledComponents/input_field.style'
import React ,{ useRef,useState } from "react";
import { gql, useMutation } from '@apollo/client';

import Cookies from 'js-cookie';
import LocationAutocomplete from './widgets/autocomplete_inputfield';
import { toaster } from 'evergreen-ui';

export const ADD_ESTATE = gql`
mutation Facility_create($name: String!, $address: String!, $country: String!, $state: String!, $city: String!) {
  facility_create(name: $name, address: $address, country: $country, state: $state, city: $city) {
    code
    success
    error
    data {
      _id
      code
      name
      facilityManager
      totalProperties
      occupiedProperties
      availableProperties
      address
      country
      state
      city
      createdAt
      id
    }
  }
}
`;



function AddEstatePageWidget() {
const accesTokenValue = Cookies.get('userAccessToken');


const [addEstate, { loading }] = useMutation(ADD_ESTATE);

const handleSubmit=(e)=>{
    e.preventDefault()
   
    addEstate({
        variables: { 
          name: nameRef.current.value,
          address:address,
          country: selectedLocation.country,
          state:selectedLocation.state,
          city: selectedLocation.city,
        },
        context: {
          headers: {
            Authorization: `Bearer ${accesTokenValue}`,
          },
        },
      })
      .then((response) => {
        toaster.success("Estate added successfully.")
        window.location.reload()
      })
      .catch((error) => {
        toaster.danger(error.message)
      });
  }


const nameRef = useRef(null);
const [selectedLocation, setSelectedLocation] = useState(null);
const [address, setAddress] = useState('');

const handleSelectLocation = (latLng, address,country,state,city) => {
setSelectedLocation({
    country,
    state,city
});
setAddress(address);
};

  return (
    <div className=''>
       <br/><br/>
        <div className='row'>
            <div className='col s12 m12 l2'></div>
            <div className='col s12 m12 l8'>
                <form onSubmit={handleSubmit}>
                <AddNewEstateContainer>
                    <AddNewEstateContainerTitleSection>
                        <PageTitleText className='pl-16 pt-25 p-16'  style={{
                                color:"#4F46E5 !important",
                                padding:"16px !important"
                            }}>
                                Add Estate 
                        </PageTitleText>
                    </AddNewEstateContainerTitleSection>


                    <div className='p-16'>
                        <div className='row'>
                            <div className='col s12 m12 l6'>
                                <InputFieldTitleText>
                                    Estate Name
                                </InputFieldTitleText>
                                <AppInputField
                                    type="text" 
                                    placholder="alijames@gmail.com"
                                    ref={nameRef}
                                required/> 
                            </div>
                            
                            <div className='col s12 m12 l6'>
                                <InputFieldTitleText>
                                    Location
                                </InputFieldTitleText>
                                <LocationAutocomplete onSelect={handleSelectLocation} />
                                {selectedLocation && (
                                    <div>
                                    {/* <h2>Selected Location:</h2> */}
                                    <small>Address: {address}</small>
                                    {/* <p>Latitude: {selectedLocation.lat}</p>
                                    <p>Longitude: {selectedLocation.lng}</p> */}
                                    </div>
                                )}
                            </div>
                            
                            <div className='row'>
                                
                                <div className='col s12 right' style={{
                                    display:"flex",
                                    flexWrap:"wrap",
                                    justifyContent:"end"
                                }}>
                                    
                                    <div className='' style={{
                                        width:"100px",
                                        padding:"16px "
                                    }}>
                                        <AppInputFieldBtnCancel 
                                    >
                                            Cancel
                                        </AppInputFieldBtnCancel >
                                    </div>
                                    <div className='' style={{
                                        width:"120px",
                                        padding:"16px "
                                    }}>
                                        <AppInputFieldBtn className='' disabled={loading}>
                                            Add
                                        </AppInputFieldBtn>
                                    </div>
                                </div>
                            </div>
                            <br/>
                        </div>
                        
                    </div>
                    

                </AddNewEstateContainer>
                </form>
            </div>
            <div className='col s12 m12 l2'></div>
        </div>
           
       
    </div>
  )
}

export default AddEstatePageWidget